import type { AccountDropdownLook } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/account/account-atoms/account-dropdown';
import AccountButton from './components/account-button';
import CartButtonMenu from './components/cart-button-menu';

export interface Props {
  icon: any;
  overlayClassName?: string;
  panelClassName?: string;
  accountPanelPositionClassName?: string;
  accountDropdownLook?: AccountDropdownLook;
  rowSurfaceClassName?: string;
}

const UtilitySection: React.FC<Props> = ({
  icon,
  overlayClassName,
  panelClassName,
  accountPanelPositionClassName,
  accountDropdownLook,
  rowSurfaceClassName,
}) => {
  return (
    <div className="flex h-40 items-center" data-testid="utility-menu">
      <div className="flex w-full justify-center">
        <AccountButton
          overlayClassName={overlayClassName}
          panelClassName={panelClassName}
          panelPositionClassName={accountPanelPositionClassName}
          dropdownLook={accountDropdownLook}
        />
        <CartButtonMenu
          icon={icon}
          overlayClassName={overlayClassName}
          panelClassName={panelClassName}
          rowSurfaceClassName={rowSurfaceClassName}
        />
      </div>
    </div>
  );
};

export default UtilitySection;
